import axios from 'axios'
import { SnackData } from '../components/Snacks'

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL,
  baseURL: 'https://my-json-server.typicode.com/marcelo-site/foodcomerce_json',
})
export const getBurggers = () => api.get<SnackData[]>('/burggers')
export const getPizzas = () => api.get<SnackData[]>('/pizzas')
export const getDrinks = () => api.get<SnackData[]>('/drinks')
export const getIceCreams = () => api.get<SnackData[]>('/ice-creams')

export default api
